class VatSwitcher extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');

    // Get the initial value from session storage
    const storedValue = sessionStorage.getItem('exclude-vat');
    if (storedValue !== null) {
      const isEx = storedValue === 'true';
      this.input.checked = isEx;
      this.classList.toggle('exclude-vat', isEx);
      document.body.classList.toggle('exclude-vat', isEx);
    }
    
    this.input.addEventListener('change', this.changeHandler.bind(this));
  }

  changeHandler(e) {
    let isEx = e.target.checked;

    // Updates the input value
    this.classList.toggle('exclude-vat', isEx);

    // Updates the body class
    document.body.classList.toggle('exclude-vat', isEx);

    // Updates the session storage
    sessionStorage.setItem('exclude-vat', isEx);

    // Updates all other instances of vat-switcher (except this one)
    document.querySelectorAll('vat-switcher').forEach((el) => {
      if (el !== this) {  // Skip the current instance
        let input = el.querySelector('input');
        if (input && input.checked !== isEx) {  // Only update if different
          input.checked = isEx;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }
}

customElements.define('vat-switcher', VatSwitcher);

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
constructor() {
  super();
  this.input = this.querySelector('input');
  this.select = this.querySelector('select');
  this.changeEvent = new Event('change', { bubbles: true });

  this.input?.addEventListener('change', this.onInputChange.bind(this));
  this.querySelectorAll('button').forEach(button =>
    button.addEventListener('click', this.onButtonClick.bind(this))
  );

  // Sync all selects/inputs with same name + form
  if (this.select) {
    const formId = this.select.getAttribute('form');
    const name = this.select.name;

    const linkedElements = Array.from(document.querySelectorAll(
      `select[name="${name}"][form="${formId}"], input[name="${name}"][form="${formId}"]`
    ));

    linkedElements.forEach(el => {
      el.addEventListener('change', (e) => {
        const newVal = e.target.value;

        linkedElements.forEach(target => {
          if (target !== e.target && target.value !== newVal) {
            target.value = newVal;
            target.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        if (this.input && this.input.value !== newVal) {
          this.input.value = newVal;
          this.input.dispatchEvent(this.changeEvent);
        }
      });
    });
  }
}

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
    if (this.select && this.select.value !== this.input.value) {
      this.select.value = this.input.value;
    }

    // Update the sticky quantity input if it exists
    const stickyQty = document.getElementById('Select-sticky-quantity');
    if (stickyQty && stickyQty.value !== this.input.value) {
      stickyQty.value = this.input.value;
      stickyQty.dispatchEvent(new Event('change', { bubbles: true }));
    }

    publish(PUB_SUB_EVENTS.addonChange, {
      variantId: this.input.name,
      quantity: parseInt(this.input.value - 1),
    });
  }

  onButtonClick(event) {
    event.preventDefault();
    const prev = this.input.value;

    if (event.target.name === 'plus') {
      if (
        parseInt(this.input.dataset.min) > parseInt(this.input.step) &&
        this.input.value == 0
      ) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (prev !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === prev && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    if (this.input) {
      const val = parseInt(this.input.value);
      const min = parseInt(this.input.min || 0);
      const max = parseInt(this.input.max || Infinity);
  
      const btnMinus = this.querySelector(".quantity__button[name='minus']");
      const btnPlus = this.querySelector(".quantity__button[name='plus']");
  
      if (btnMinus) btnMinus.classList.toggle('disabled', val <= min);
      if (btnPlus) btnPlus.classList.toggle('disabled', val >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}


function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.mainContent = document.getElementById('MainContent');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    this.mainContent.classList.add('laying-prioritise');
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainContent.classList.remove('laying-prioritise');
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = this.dataset.loop !== 'false';
    
    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    if (this.enableSliderLooping) {
      this.prevButton.removeAttribute('disabled');
    }

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this._savedLeft = null;
  }

  connectedCallback() {
    const SLIDER_SEL = '.color-swatch-slider .slider';
    const getSlider = () => this.querySelector(SLIDER_SEL);
    if (this.dataset.variants && !this.variants) {
      try {
        this.variants = JSON.parse(this.dataset.variants);
      } catch (e) {
        this.variants = null;
      }
    }

    const save = () => {
      const el = getSlider();
      if (!el) return;
      this._savedLeft = el.scrollLeft;
      // store on the parent <product-info> so we can read it after replacement
      this.closest('product-info')?.setAttribute('data-color-scroll', String(this._savedLeft));
    };
    if (window.matchMedia('(max-width: 749px)').matches) {
      // capture-phase so we beat any sync layout/class toggles
      this.addEventListener('pointerdown', save, { capture: true, passive: true });
      this.addEventListener('touchstart', save, { capture: true, passive: true });
      this.addEventListener('keydown', (e)=>{ if (e.key === 'Enter' || e.key === ' ') save(); }, { capture: true });
    }

this.addEventListener('change', (event) => {
  this.updateOtherSelectors(event);

  let target = this.getInputForEventTarget(event.target);
  this.updateSelectionMetadata(event);

  // NEW: if the chosen combo is not available, fix it before firing the event
  target = this.ensureValidVariantSelection(target);

  if (window.matchMedia('(max-width: 749px)').matches) {
    const slider = getSlider();
    if (slider != null && this._savedLeft != null) {
      slider.scrollLeft = this._savedLeft;
    }
  }

  publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
    data: {
      event,
      target,
      selectedOptionValues: this.selectedOptionValues,
    },
  });
});



    if (window.matchMedia('(max-width: 749px)').matches) {
      const root = this.closest('.shopify-section.section-main-product') || this;
      const restore = () => {
        const el = getSlider();
        if (!el || this._savedLeft == null) return;

        // Guard against layout changes & scroll-snap jitters
        const snap = el.style.scrollSnapType;
        const behavior = el.style.scrollBehavior;
        el.style.scrollSnapType = 'none';
        el.style.scrollBehavior = 'auto';

        const maxLeft = Math.max(0, el.scrollWidth - el.clientWidth);
        el.scrollLeft = Math.min(this._savedLeft, maxLeft);

        el.style.scrollBehavior = behavior || '';
        el.style.scrollSnapType = snap || '';
        this._savedLeft = null;
      };

      const mo = new MutationObserver((muts) => {
        // If the slider or its children were touched, restore on the next frame
        const touched = muts.some(m =>
          (m.target && (m.target === getSlider() || m.target.closest?.(SLIDER_SEL))) ||
          [...m.addedNodes].some(n => n.nodeType === 1 && (n.matches?.(SLIDER_SEL) || n.querySelector?.(SLIDER_SEL)))
        );
        if (touched) requestAnimationFrame(() => requestAnimationFrame(restore));
      });
      mo.observe(root, { childList: true, subtree: true });

      const el = getSlider();
      if (!el) return;
      const selectedSwatch = el.querySelector('fieldset input[type="radio"]:checked').nextElementSibling;
      const leftPosition = selectedSwatch.offsetLeft;
      el.scrollLeft = leftPosition - 16;
    }
  }

  updateOtherSelectors({ target }) {
    const { value, tagName } = target;

    let optionValueId = target.dataset.optionValueId;

    if (tagName === 'SELECT') {
      optionValueId = target.selectedOptions[0].dataset.optionValueId;
    }

    let associatedOptions = this.querySelectorAll(`[data-option-value-id="${optionValueId}"]`);
    let targetToCheck = null;

    if (tagName == 'SELECT') {
      targetToCheck = target.selectedOptions[0];
    } else {
      targetToCheck = target;
    }

    if (associatedOptions.length > 1) {
      for (const associatedOption of associatedOptions) {
        if (associatedOption != targetToCheck) {
          if (associatedOption.tagName == 'OPTION') {
            associatedOption.parentElement.value = value;
            
            for (const associatedSelectOption of associatedOption.parentElement.children) {
              if (associatedSelectOption == associatedOption) {
                associatedSelectOption.selected = 'selected';
              } else {
                associatedSelectOption.removeAttribute('selected');
              }
            }
          } else if (associatedOption.tagName == 'INPUT') {
            associatedOption.checked = true;
          }
        }
      }
    }
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options).find((option) => option.getAttribute('selected')).removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

ensureValidVariantSelection(target) {
  if (!this.variants || !this.variants.length) return target;

  const colorWrapper = this.querySelector('.product-form__input--color-pdp');
  const colorInput =
    colorWrapper &&
    (colorWrapper.querySelector('input[type="radio"]:checked') ||
      colorWrapper.querySelector('select'));
  const colorValue = colorInput
    ? (colorInput.value || (colorInput.selectedOptions && colorInput.selectedOptions[0].value))
    : null;

  const sizeWrapper = this.querySelector(
    '.product-form__input--pill--size, .product-form__input--pill--Size'
  );
  let sizeValue = null;
  if (sizeWrapper) {
    const sizeRadio = sizeWrapper.querySelector('input[type="radio"]:checked');
    const sizeSelect = sizeWrapper.querySelector('select');
    if (sizeRadio) sizeValue = sizeRadio.value;
    else if (sizeSelect && sizeSelect.selectedOptions.length) sizeValue = sizeSelect.selectedOptions[0].value;
  }

  const matchesSelection = (v) => {
    const opts = [v.option1, v.option2, v.option3];
    if (colorValue && !opts.includes(colorValue)) return false;
    if (sizeValue && !opts.includes(sizeValue)) return false;
    return true;
  };

  // 1) If exact available exists, keep it.
  const exact = this.variants.find((v) => v.available && matchesSelection(v));
  if (exact) return target;

  // 2) If a colour is picked, prefer first available for that colour…
  if (colorValue) {
    const forColor = this.variants.find((v) => {
      if (!v.available) return false;
      const opts = [v.option1, v.option2, v.option3];
      return opts.includes(colorValue);
    });

    if (forColor) {
      this.applyVariantSelection(forColor);
      return this.getFirstSelectedInput() || target;
    }

    // …otherwise: DO NOT FALL BACK TO A DIFFERENT COLOUR.
    // Keep the colour selected with all sizes crossed out.
    return target;
  }

  // 3) Only when no colour is involved (e.g., size-first products), use global fallback.
  const firstAvailable = this.variants.find((v) => v.available);
  if (firstAvailable) {
    this.applyVariantSelection(firstAvailable);
    return this.getFirstSelectedInput() || target;
  }

  return target;
}

applyVariantSelection(variant) {
  const values = [variant.option1, variant.option2, variant.option3].filter(Boolean);

  values.forEach((val) => {
    if (!val) return;

    const radio = this.querySelector(`input[type="radio"][value="${CSS.escape(val)}"]`);
    if (radio) {
      radio.checked = true;
      return;
    }

    const select = this.querySelector('select');
    if (select) {
      const opt = Array.from(select.options).find((o) => o.value === val);
      if (opt) {
        select.value = val;
        opt.selected = true;
      }
    }
  });
}

getFirstSelectedInput() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (checked) return checked;
    const select = this.querySelector('select');
    if (select && select.selectedOptions.length) {
      return select.selectedOptions[0];
    }
    return null;
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    // if it's inside the cart drawer, fetch immediately
    if (this.dataset.onCartDrawer === 'true') {
      this.loadRecommendations(this.dataset.productId);
      return;
    }
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 1200px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
                    const slider = this.closest('slider-component');
          if (slider) {
            if (slider.slider) {
              slider.resetPages();
            } else {
              slider.slider = slider.querySelector('[id^="Slider-"]');
              slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]');
              if (slider.slider) {
                slider.initPages();
                const resizeObserver = new ResizeObserver(() => slider.initPages());
                resizeObserver.observe(slider.slider);
                slider.slider.addEventListener('scroll', slider.update.bind(slider));
                slider.prevButton.addEventListener('click', slider.onButtonClick.bind(slider));
                slider.nextButton.addEventListener('click', slider.onButtonClick.bind(slider));
              }
            }
          }
          window.observeCrossSellCards && window.observeCrossSellCards();
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    if (!input) return;
    input.value = input.getAttribute('value');
    input.dispatchEvent(new Event('change', { bubbles: true }));

    const select = this.querySelector('select[name="quantity"]');
    if (select) {
      select.value = input.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance"

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      startMarker.name,
      `${metricName}:end`
    );
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(
      benchmarkName,
      `${metricName}:start`,
      `${metricName}:end`
    );
  }
}

function updateSavingsBars(cartTotal) {
  document.querySelectorAll('savings-bar').forEach((bar) => {
    bar.updateProgress(cartTotal);
  });
}

function updateSavingsBarsPrice(price) {
  document.querySelectorAll('savings-bar').forEach((bar) => {
    bar.dataset.price = price;
    bar.updatePrices();
  });
}

class SavingsBar extends HTMLElement {
  constructor() {
    super();
    this.progress = this.querySelector('progress');
    this.message = this.querySelector('.savings-message');
    this.hasFreeShipping = this.dataset.hasFreeShipping === 'true';
    this.activeTier = parseInt(this.dataset.activeDiscount || '0', 10);
    this.freeShippingThreshold = parseFloat(this.dataset.freeShippingThreshold || '0');
    
    // Read threshold <span> elements and convert their data-value from GBP to local currency
    const thresholdElements = this.querySelectorAll('.thresholds span');
    this.thresholds = Array.from(thresholdElements).map((span) => {
      const value = parseFloat(span.dataset.value) || 0;
      const localValue = value;  // convert to local currency

      return {
        value: localValue,
        label: span.textContent.trim(), // used later in updateMessage
      };
    });

    // The <progress> max is the number of thresholds
    this.progress.max = this.thresholds.length;
    this.currentProgress = 0;

    // If on product pages, display discount prices
    this.updatePrices();
  }

  connectedCallback() {
    if (!this.classList.contains('savings-bar--standalone')) return;
    this.footerVisible = false;
    this.observeFooter();
  }

  observeFooter() {
    const footer = document.querySelector('footer');
    if (footer) {
      const observer = new IntersectionObserver((entries) => {
        this.footerVisible = entries[0].isIntersecting;
        this.updateVisibility();
      });
      observer.observe(footer);
    } else {
      this.updateVisibility();
    }
  }

  updateVisibility() {
    if (this.footerVisible) {
      this.classList.remove('visible');
    } else {
      this.classList.add('visible');
    }
  }

  updateMessage(surpassed, cartTotal) {
    if (!this.message) return;

    if (this.hasFreeShipping && this.freeShippingThreshold > 0 && cartTotal < this.freeShippingThreshold) {
      const amountNeeded = this.freeShippingThreshold - cartTotal;
      this.message.textContent = savings_bar.spend_more_for_free_shipping.replace(
        '{{ amount_needed }}',
        Shopify.formatMoney(amountNeeded * 100, Shopify.moneyFormat)
      );
      return;
    }

    if (surpassed < this.thresholds.length) {
      const nextThreshold = this.thresholds[surpassed];
      const amountNeeded = nextThreshold.value - cartTotal;
      this.message.textContent = savings_bar.spend_more_for_discount
        .replace('{{ amount_needed }}', Shopify.formatMoney(amountNeeded * 100, Shopify.moneyFormat))
        .replace('{{ next_threshold }}', nextThreshold.label);
    } else {
      this.message.textContent = savings_bar.maximum_savings;
    }
  }

  updateProgress(cartTotalInCents) {
    const cartTotalInLocal = cartTotalInCents / 100; // e.g. 5000 => 50.00 in local
    let surpassed = 0;

    // Figure out how many thresholds are surpassed
    for (let i = 0; i < this.thresholds.length; i++) {
      if (cartTotalInLocal >= this.thresholds[i].value) {
        surpassed = i + 1;
      } else {
        break;
      }
    }

    if (this.activeTier > surpassed) {
      surpassed = this.activeTier;
    }

    // Calculate progress value (for <progress>)
    let value;
    if (surpassed === 0) {
      // Before first threshold
      value = (cartTotalInLocal / this.thresholds[0].value) * 0.5;
    } else if (surpassed < this.thresholds.length) {
      // Between thresholds
      const prevThreshold = this.thresholds[surpassed - 1].value;
      const nextThreshold = this.thresholds[surpassed].value;
      value =
        surpassed -
        0.5 +
        ((cartTotalInLocal - prevThreshold) / (nextThreshold - prevThreshold)) * 1;
    } else {
      // Beyond last threshold
      value = this.thresholds.length; // fully "maxed" out
    }

    // Safety: cap value at least activeTier's threshold progress and at max
    const minActiveProgress = this.activeTier > 0 ? this.activeTier - 0.5 : 0;
    value = Math.max(value, minActiveProgress);
    value = Math.min(value, this.thresholds.length);
    this.currentProgress = value;
    this.progress.value = value;
    this.progress.style.setProperty('--progress', value / this.thresholds.length);

    // Mark how many thresholds we've hit
    this.dataset.active = surpassed;

    // Update the displayed message above the bar
    this.updateMessage(surpassed, cartTotalInLocal);
  }

  updatePrices() {
    const basePrice = parseInt(this.dataset.price, 10) || 0; // price in cents
    const vatRate = parseFloat(this.dataset.vatRate) / 100;

    // If the template doesn't contain product info, skip
    if (!basePrice) return;

    const priceContainers = this.querySelectorAll('.thresholds-prices');

    priceContainers.forEach((container) => {
      const includesVAT = container.classList.contains('price--including-vat');
      const priceSpans = container.querySelectorAll('span');

      priceSpans.forEach((span) => {
        const discountPercentage = parseFloat(span.dataset.discountPercentage) || 0;
        const discountFactor = 1 - discountPercentage / 100;
        let finalPrice = basePrice * discountFactor;

        if (!includesVAT && this.querySelector('.price--including-vat')) {
          // Remove VAT portion and round to match Liquid formatting
          finalPrice = Math.round(finalPrice / (1 + vatRate));
        }
        finalPrice = Math.round(finalPrice);

        span.textContent = Shopify.formatMoney(finalPrice, Shopify.money_format);
      });
    });
  }
}

customElements.define('savings-bar', SavingsBar);

subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  // Fetch the complete cart data
  fetch('/cart.js')
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok.');
      }
      return response.json();
    })
    .then(cart => {
      updateSavingsBars(cart.original_total_price);
      refreshProductPageInfo();
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
});

function refreshProductPageInfo() {
  let productInfos = document.querySelectorAll('product-info');

  if (productInfos) {
    for (const productInfo of productInfos) {
      let variantSelects = productInfo.querySelector('variant-selects');

      if (variantSelects) {
        variantSelects.dispatchEvent(new Event('change'));
      } else {
        const shouldFetchFullPage = productInfo.dataset.updateUrl === 'true' || productInfo.dataset.onCard === 'true';
        const productUrl = productInfo.dataset.url;
  
        productInfo.renderProductInfo({
          requestUrl: productInfo.buildRequestUrlWithParams(productUrl, null, shouldFetchFullPage),
          targetId: productInfo.id,
          callback: productInfo.handleUpdateProductInfo(productUrl),
        });
      }
    }
  }
}

class CardVariantsList extends HTMLElement {
  constructor() {
    super();
    this.resizeObserver = null;
    this.renderVariants = this.renderVariants.bind(this); // bind once

    // Exclude `.more-variants` and filter out non-variant items
    this.childrenList = [...this.children].filter(
      child => !child.classList.contains('more-variants') && child.hasAttribute('data-variant-id')
    );
  }

  connectedCallback() {
    // Setup resize observer instead of global resize
    this.resizeObserver = new ResizeObserver(this.renderVariants);
    this.resizeObserver.observe(this);

    this.renderVariants();
  }

  disconnectedCallback() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  renderVariants() {
    const containerWidth = this.offsetWidth;

    if (this.childrenList.length === 0) return;

    const childWidth = this.childrenList[0].offsetWidth || 0;
    const visibleSlots = Math.floor(containerWidth / childWidth);

    const totalVariants = this.childrenList.length;
    const moreVariantsBox = this.querySelector('.more-variants');

    if (visibleSlots >= totalVariants) {
      // All variants fit — show all
      this.childrenList.forEach(child => child.classList.remove('hidden'));
      if (moreVariantsBox) moreVariantsBox.classList.add('hidden');
    } else {
      // Some hidden — reserve 1 slot for "+N"
      const shownCount = Math.max(visibleSlots - 1, 0);
      const hiddenCount = totalVariants - shownCount;

      this.childrenList.forEach((child, index) => {
        child.classList.toggle('hidden', index >= shownCount);
      });

      if (moreVariantsBox) {
        moreVariantsBox.classList.remove('hidden');
        const span = moreVariantsBox.querySelector('span');
        if (span) span.textContent = hiddenCount;
      }
    }
  }
}

customElements.define('card-variants-list', CardVariantsList);

// Resize observer to toggle horizontal layout for cross-sell cards
const mobileWidthThreshold = 768;
const crossSellResizeObserver = new ResizeObserver((entries) => {
  const isMobile = window.innerWidth < mobileWidthThreshold;
  entries.forEach(({ target }) => {
    target.classList.toggle('card--horizontal', isMobile);
  });
});

window.observeCrossSellCards = () => {
  document
    .querySelectorAll('.card--cross-sell:not(.card--on-cart-drawer)')
    .forEach((card) => crossSellResizeObserver.observe(card));
};

document.addEventListener('DOMContentLoaded', () => {
  window.observeCrossSellCards();
});

class CollapsibleContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Select all child <details> elements inside this component
    const detailsList = this.querySelectorAll('details');

    detailsList.forEach(details => {
      details.addEventListener('toggle', () => {
        if (details.open) {
          // Close all other open <details> in this container
          detailsList.forEach(other => {
            if (other !== details && other.open) {
              other.open = false;
            }
          });
        }
      });
    });
  }
}

// Define the custom element
customElements.define('collapsible-content', CollapsibleContent);

class FlFeefoBadge extends HTMLElement {
  async connectedCallback() {
    const merchant = this.getAttribute('merchant');
    const version  = this.getAttribute('version')      ?? '20';
    const mode     = this.getAttribute('mode')         ?? 'all';
    const since    = this.getAttribute('since-period') ?? 'all';    // month | year | all

    if (!merchant) {
      this.textContent = '⚠ Missing merchant_identifier';
      return;
    }

    // include since_period=all to get every review, not just last year
    const url = `https://api.feefo.com/api/${version}/reviews/summary/${mode}`
              + `?merchant_identifier=${merchant}`
              + `&since_period=${since}`;

    try {
      const res  = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();

      const score = (+data?.rating?.rating || 0).toFixed(1);
      const count = data?.rating?.service?.count
                 ?? data?.rating?.product?.count
                 ?? data?.meta?.count
                 ?? 0;

      this.querySelector('.feefo-score').textContent = score;
      this.querySelector('.feefo-count').textContent = count.toLocaleString();
      
      let stars = this.querySelector('.feefo-rating-stars');
      if (stars) {
        stars.dataset.stars = Math.round(score);
      }
    } catch (err) {
      console.error('FeefoBadge error', err);
      this.textContent = 'Unable to load Feefo rating';
    }
  }
}

customElements.define('fl-feefo-badge', FlFeefoBadge);

class FlFeefoProductStars extends HTMLElement {
  async connectedCallback() {
    const merchant   = this.getAttribute('merchant');
    const sku        = this.getAttribute('product-sku') || this.getAttribute('sku');
    const parentSku  = this.getAttribute('parent-product-sku');
    const version  = this.getAttribute('version')      ?? '10';
    const since    = this.getAttribute('since-period') ?? 'all';

    if (!merchant || (!sku && !parentSku)) {
      this.textContent = '⚠ Missing merchant_identifier or product_sku';
      return;
    }

    try {
      let url = `https://api.feefo.com/api/${version}/reviews/summary/product?merchant_identifier=${merchant}&since_period=${since}`;
      if (parentSku) {
        url += `&parent_product_sku=${parentSku}`;
      } else {
        url += `&product_sku=${sku}`;
      }
      const res = await fetch(url);
      if (!res.ok) throw new Error(res.statusText);
      const data = await res.json();

      const rating = (+data?.rating?.rating || 0).toFixed(1);
      const count  = data?.rating?.product?.count ?? data?.meta?.count ?? 0;
      if (count == 0) {
        this.closest('.card__rating')?.remove();
        return;
      }
      let starsCode = '';

      for (let step = 0; step < 5; step++) {
        if (step < rating) {
          starsCode += `
            <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.71741 12.0401C2.55944 12.163 2.39537 12.168 2.22521 12.0553C2.05503 11.9426 1.99884 11.79 2.05664 11.5975L3.29919 7.56048L0.188017 5.33777C0.0133659 5.21872 -0.0396087 5.06294 0.0290932 4.87043C0.0978119 4.67793 0.229773 4.58168 0.424977 4.58168H4.32789L5.60124 0.444001C5.63463 0.337608 5.6876 0.259714 5.76016 0.210321C5.83272 0.160927 5.91267 0.13623 6 0.13623C6.08733 0.13623 6.16728 0.160927 6.23984 0.210321C6.3124 0.259714 6.36537 0.337608 6.39876 0.444001L7.67211 4.58168H11.575C11.7702 4.58168 11.9022 4.67793 11.9709 4.87043C12.0396 5.06294 11.9866 5.21872 11.812 5.33777L8.70081 7.56048L9.94336 11.5975C10.0012 11.79 9.94497 11.9426 9.77479 12.0553C9.60463 12.168 9.44056 12.1639 9.28259 12.0401L6 9.58945L2.71741 12.0401Z" fill="#231F20"/>
              <path d="M2.71741 12.0401C2.55944 12.163 2.39537 12.168 2.22521 12.0553C2.05503 11.9426 1.99884 11.79 2.05664 11.5975L3.29919 7.56048L0.188017 5.33777C0.0133659 5.21872 -0.0396087 5.06294 0.0290932 4.87043C0.0978119 4.67793 0.229773 4.58168 0.424977 4.58168H4.32789L5.60124 0.444001C5.63463 0.337608 5.6876 0.259714 5.76016 0.210321C5.83272 0.160927 5.91267 0.13623 6 0.13623C6.08733 0.13623 6.16728 0.160927 6.23984 0.210321C6.3124 0.259714 6.36537 0.337608 6.39876 0.444001L7.67211 4.58168H11.575C11.7702 4.58168 11.9022 4.67793 11.9709 4.87043C12.0396 5.06294 11.9866 5.21872 11.812 5.33777L8.70081 7.56048L9.94336 11.5975C10.0012 11.79 9.94497 11.9426 9.77479 12.0553C9.60463 12.168 9.44056 12.1639 9.28259 12.0401L6 9.58945L2.71741 12.0401Z" fill="#231F20"/>
            </svg>`;
        } else {
          starsCode += `
            <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.17031 14.3908C2.98601 14.5341 2.7946 14.54 2.59608 14.4085C2.39754 14.277 2.33198 14.099 2.39942 13.8744L3.84905 9.16456L0.219354 6.5714C0.0155936 6.4325 -0.0462101 6.25075 0.0339421 6.02617C0.114114 5.80158 0.268068 5.68929 0.495806 5.68929H5.0492L6.53478 0.861996C6.57373 0.73787 6.63554 0.646994 6.72019 0.589369C6.80484 0.531743 6.89811 0.50293 7 0.50293C7.10189 0.50293 7.19516 0.531743 7.27981 0.589369C7.36446 0.646994 7.42627 0.73787 7.46522 0.861996L8.9508 5.68929H13.5042C13.7319 5.68929 13.8859 5.80158 13.9661 6.02617C14.0462 6.25075 13.9844 6.4325 13.7806 6.5714L10.1509 9.16456L11.6006 13.8744C11.668 14.099 11.6025 14.277 11.4039 14.4085C11.2054 14.54 11.014 14.5341 10.8297 14.3908L7 11.5317L3.17031 14.3908ZM4.19516 12.201L7 10.091L9.80484 12.201L8.77549 8.70799L11.3826 6.8418H8.11025L7 3.269L5.88975 6.8418H2.61743L5.22451 8.70799L4.19516 12.201Z" fill="#231F20"/>
            </svg>
          `;
        }
      }
      this.innerHTML = `
        <div class="feefo-rating-stars">${starsCode}</div>
        <span class="feefo-count"></span>
      `;

      const stars = this.querySelector('.feefo-rating-stars');
      if (stars) stars.dataset.stars = Math.round(rating);

      const scoreEl = this.querySelector('.feefo-score');
      if (scoreEl) scoreEl.textContent = rating;

      const countEl = this.querySelector('.feefo-count');
      if (countEl) countEl.textContent = count.toLocaleString();

      if (this.classList.contains('fl-feefo-product-stars-pdp')) {
        this.addEventListener('click', (event) => {
          document.querySelector('.section-product-reviews').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    } catch (err) {
      console.error('FeefoProductStars error', err);
      this.textContent = 'Unable to load rating';
    }
  }
}

customElements.define('fl-feefo-product-stars', FlFeefoProductStars);

class FlFeefoReviewsCarousel extends HTMLElement {
  constructor() {
    super();
  }

  async connectedCallback() {
    const merchant = this.getAttribute('merchant') || 'your-merchant-id';

    const response = await fetch(`https://api.feefo.com/api/20/reviews/all?merchant_identifier=${merchant}&since_period=all`);
    const data = await response.json();

    const reviews = data.reviews || [];

    this.updateReviews(reviews);
  }

  updateReviews(reviews) {
    const reviewsContainer = this.querySelector('.grid');
    
    for (const review of reviews) {
      const displayName = review.customer?.display_name;
      const fallback = review.service?.title;

      if (review.service) {
        console.log(review.service.rating.rating);
        if (review.service.rating.rating > 4) {
          reviewsContainer.innerHTML += `
            <div class="grid__item slider__slide">
              <div class="feefo-review-carousel--item color-scheme-2">
                <p class="text-body-large text-bold">
                  ${fallback}
                </p>
                <div class="feefo-reviews-carousel--rating-stars feefo-rating-stars" data-stars="${Math.round(review.service.rating.rating)}">
                  ${[...Array(5)].map((_, i) => Math.round(review.service.rating.rating) > i ? `
                      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2.71741 12.0401C2.55944 12.163 2.39537 12.168 2.22521 12.0553C2.05503 11.9426 1.99884 11.79 2.05664 11.5975L3.29919 7.56048L0.188017 5.33777C0.0133659 5.21872 -0.0396087 5.06294 0.0290932 4.87043C0.0978119 4.67793 0.229773 4.58168 0.424977 4.58168H4.32789L5.60124 0.444001C5.63463 0.337608 5.6876 0.259714 5.76016 0.210321C5.83272 0.160927 5.91267 0.13623 6 0.13623C6.08733 0.13623 6.16728 0.160927 6.23984 0.210321C6.3124 0.259714 6.36537 0.337608 6.39876 0.444001L7.67211 4.58168H11.575C11.7702 4.58168 11.9022 4.67793 11.9709 4.87043C12.0396 5.06294 11.9866 5.21872 11.812 5.33777L8.70081 7.56048L9.94336 11.5975C10.0012 11.79 9.94497 11.9426 9.77479 12.0553C9.60463 12.168 9.44056 12.163 9.28259 12.0401L6 9.58945L2.71741 12.0401ZM3.59585 10.1632L6 8.35459L8.40415 10.1632L7.52185 7.16914L9.75648 5.56955H6.95164L6 2.50715L5.04836 5.56955H2.24352L4.47815 7.16914L3.59585 10.1632Z" fill="#231F20"/>
                        <path d="M2.71741 12.0401C2.55944 12.163 2.39537 12.168 2.22521 12.0553C2.05503 11.9426 1.99884 11.79 2.05664 11.5975L3.29919 7.56048L0.188017 5.33777C0.0133659 5.21872 -0.0396087 5.06294 0.0290932 4.87043C0.0978119 4.67793 0.229773 4.58168 0.424977 4.58168H4.32789L5.60124 0.444001C5.63463 0.337608 5.6876 0.259714 5.76016 0.210321C5.83272 0.160927 5.91267 0.13623 6 0.13623C6.08733 0.13623 6.16728 0.160927 6.23984 0.210321C6.3124 0.259714 6.36537 0.337608 6.39876 0.444001L7.67211 4.58168H11.575C11.7702 4.58168 11.9022 4.67793 11.9709 4.87043C12.0396 5.06294 11.9866 5.21872 11.812 5.33777L8.70081 7.56048L9.94336 11.5975C10.0012 11.79 9.94497 11.9426 9.77479 12.0553C9.60463 12.168 9.44056 12.163 9.28259 12.0401L6 9.58945L2.71741 12.0401Z" fill="#231F20"/>
                      </svg>
                    ` : `
                      <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M3.17031 14.3908C2.98601 14.5341 2.7946 14.54 2.59608 14.4085C2.39754 14.277 2.33198 14.099 2.39942 13.8744L3.84905 9.16456L0.219354 6.5714C0.0155936 6.4325 -0.0462101 6.25075 0.0339421 6.02617C0.114114 5.80158 0.268068 5.68929 0.495806 5.68929H5.0492L6.53478 0.861996C6.57373 0.73787 6.63554 0.646994 6.72019 0.589369C6.80484 0.531743 6.89811 0.50293 7 0.50293C7.10189 0.50293 7.19516 0.531743 7.27981 0.589369C7.36446 0.646994 7.42627 0.73787 7.46522 0.861996L8.9508 5.68929H13.5042C13.7319 5.68929 13.8859 5.80158 13.9661 6.02617C14.0462 6.25075 13.9844 6.4325 13.7806 6.5714L10.1509 9.16456L11.6006 13.8744C11.668 14.099 11.6025 14.277 11.4039 14.4085C11.2054 14.54 11.014 14.5341 10.8297 14.3908L7 11.5317L3.17031 14.3908ZM4.19516 12.201L7 10.091L9.80484 12.201L8.77549 8.70799L11.3826 6.8418H8.11025L7 3.269L5.88975 6.8418H2.61743L5.22451 8.70799L4.19516 12.201Z" fill="#231F20"/>
                      </svg>
                    `).join('')}
                </div>
                <div class="feefo-review-carousel--content">
                  <p class="text-body">${review.service.review}</p>
                  <h3 class="text-body text-bold">${displayName !== undefined ? displayName : 'Trusted Customer'}</h3>
                  <span class="feefo-review-carousel--item-verified text-body-small">
                    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="7.0035" cy="7.13973" r="7.0035" fill="#0A8A00"/>
                      <mask id="mask0_6821_12914" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="1" width="21" height="21">
                        <rect x="1.05078" y="1.18604" width="20.4" height="20.4" fill="#D9D9D9"/>
                      </mask>
                      <g mask="url(#mask0_6821_12914)">
                        <path d="M5.78523 10.1111L2.95898 7.28483L3.66555 6.57826L5.78523 8.69795L10.3345 4.14868L11.0411 4.85524L5.78523 10.1111Z" fill="#F3F3F3"/>
                      </g>
                    </svg>
                    ${feefoReviewsTranslations.verifiedCustomer}
                  </span>
                </div>
              </div>
            </div>
          `;
        }
      }
    }

    this.redefineSlider();
  }

  redefineSlider() {
    this.parentSlider = this.querySelector('slider-component');
    this.parentSlider.slider = this.parentSlider.querySelector('[id^="Slider-"]');
    this.parentSlider.sliderItems = this.parentSlider.querySelectorAll('.slider__slide');
    this.parentSlider.prevButton = this.parentSlider.querySelector('button[name="previous"]');
    this.parentSlider.nextButton = this.parentSlider.querySelector('button[name="next"]');
    this.parentSlider.prevButton.addEventListener('click', this.parentSlider.onButtonClick.bind(this.parentSlider));
    this.parentSlider.nextButton.addEventListener('click', this.parentSlider.onButtonClick.bind(this.parentSlider));
    this.parentSlider.slider.addEventListener('scroll', this.parentSlider.update.bind(this.parentSlider));

    this.parentSlider.initPages();
  }
}

customElements.define('fl-feefo-reviews-carousel', FlFeefoReviewsCarousel);

class FeaturedCollectionSwitch extends HTMLElement {
  constructor() {
    super();
    
    let buttons = this.querySelectorAll('button');

    buttons.forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        let index = [...buttons].indexOf(event.currentTarget);

        const targetElement = this.closest('section').querySelector(`slider-component:nth-child(${index + 1})`);

        if (targetElement) {
          this.closest('section').querySelectorAll('slider-component').forEach((el) => {
            el.classList.toggle('hidden', el !== targetElement);
          });
          buttons.forEach((btn) => {
            btn.classList.toggle('active', btn === event.currentTarget);
          });
        }
      });
    });
  }
}

customElements.define('featured-collection-switch', FeaturedCollectionSwitch);

/*
How to use?
Wrap ul with elements in below element
          <infinite-scroll
            data-previous-url="{{ paginate.previous.url }}"
            data-next-url="{{ paginate.next.url }}"
            data-current-page="{{ paginate.current_page }}"
            data-current-url="{{ result.url }}">
Current URL should be set to the url of the page that the user is currently on. Above example works with Search and collection product grid.
Put previous and next buttons in around the element. Following below structure:  
            <div data-load-previous class="hide">
              <button class="button button--secondary">
                <span>BUTTON CTA GOES HERE</span>
              </button>
            </div>
Button has to be wrapped in element with data-load-previous or data-load-next attribute.
*/

class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.searchParams = new URLSearchParams(location.search);

    this.previousUrl = this.dataset.previousUrl;
    this.nextUrl = this.dataset.nextUrl;
    this.currentPage = this.dataset.currentPage;
    this.currentUrl = this.dataset.currentUrl;

    this.targetList = this.querySelector('ul');
    this.elementToObserve = this.querySelector('.infinite-scroll--observed');
    this.loadPrevious = this.querySelector('[data-load-previous]');
    this.loadNext = this.querySelector('[data-load-next]');
    this.loadPreviousButton = this.querySelector('[data-load-previous] .button');
    this.loadNextButton = this.querySelector('[data-load-next] .button');
    this.statusContainer = this.querySelector('.infinite-scroll--status');

    this.storedPage = this.searchParams.get('page');

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }

    if (this.searchParams.get('page') && parseInt(this.searchParams.get('page')) > 1) {
      this.loadPrevious.classList.remove('hide');

      this.loadPrevious.querySelector('button').addEventListener('click', e => {
        e.preventDefault();

        this.handlePrevious();
      });
    }

    this.bindCardClickEvents();
  }

  connectedCallback() {
    const savedId = sessionStorage.getItem('collection-product-id');
    if (savedId) {
      const product = this.querySelector(`[data-product-id="${savedId}"]`);
      if (product) {
        product.scrollIntoView({ block: 'start' });
      }
      sessionStorage.removeItem('collection-product-id');
    }

    if (this.elementToObserve) {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;

        this.handleNext();
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this.elementToObserve);
    }
  }

  loadingState(button, enable) {
    button.setAttribute('aria-disabled', enable);
    button.classList.toggle('loading', enable);
    button.querySelector('.loading__spinner').classList.toggle('hidden', !enable);
  }

  handlePrevious() {
    this.loadingState(this.loadPreviousButton, true);
    const params = new URLSearchParams(this.searchParams);
    params.set('page', this.storedPage - 1);

    const urlBase = this.previousUrl ? this.previousUrl.split('?')[0] : this.currentUrl;

    fetch(`${urlBase}?${params.toString()}`)
      .then((response) => response.text())
      .then((text) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(text, "text/html");

        let docInfiniteScroll = doc.querySelector('infinite-scroll');

        if (docInfiniteScroll.dataset.currentPage == '1') {
          this.loadPrevious.classList.add('hide');
        }

        this.previousUrl = docInfiniteScroll.dataset.previousUrl;
        this.nextUrl = docInfiniteScroll.dataset.nextUrl;
        this.storedPage = this.storedPage - 1;

        if (this.storedPage != 1) {
          this.searchParams.set('page', this.storedPage);
        } else {
          this.searchParams.delete('page');
        }
        window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);

        if (this.targetList) {
          this.targetList.insertAdjacentHTML('afterbegin', docInfiniteScroll.querySelector('ul').innerHTML);
        }

        this.loadedCallback();
      })
      .catch((e) => {
        console.error(e);
      });
  }

  handleNext() {
    if (this.nextUrl) {
      this.loadingState(this.loadNextButton, true);

      fetch(this.nextUrl)
        .then((response) => response.text())
        .then((text) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, "text/html");

          let docInfiniteScroll = doc.querySelector('infinite-scroll');

          this.previousUrl = docInfiniteScroll.dataset.previousUrl;
          this.nextUrl = docInfiniteScroll.dataset.nextUrl;
          this.currentPage = docInfiniteScroll.dataset.currentPage;

          if (this.currentPage != '1') {
            this.searchParams.set('page', this.currentPage);
          }

          window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);
          if (this.targetList)
            this.targetList.insertAdjacentHTML('beforeend', docInfiniteScroll.querySelector('ul').innerHTML);

          if (!this.nextUrl) {
            this.loadNext.remove();
          }

          this.loadedCallback();

          document.dispatchEvent(new CustomEvent("swym:collections-loaded"));

        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  loadedCallback() {
    this.loadPreviousButton && this.loadingState(this.loadPreviousButton, false);
    this.loadNextButton && this.loadingState(this.loadNextButton, false);

    this.bindCardClickEvents();
  }

  bindCardClickEvents() {
    let cardLinks = this.querySelectorAll('.product-grid li a');

    if (cardLinks) {
      for (const cardLink of cardLinks) {
        cardLink.addEventListener('click', e => {
          let link = e.currentTarget.href;
          let liItem = e.currentTarget.closest('li');

          if (liItem && liItem.dataset.currentPage) {
            e.preventDefault();

            let currentPage = liItem.dataset.currentPage;

            this.searchParams.set('page', currentPage);

            window.history.replaceState({}, '', `${location.pathname}?${this.searchParams}`);


            const productEl = liItem.querySelector('[data-product-id]');
            if (productEl) {
              sessionStorage.setItem('collection-product-id', productEl.dataset.productId);
            }

            window.location.href = link;
          }
        });
      }
    }
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.listId = this.dataset.listId;
    this.form = this.querySelector('form');
    this.input = this.querySelector('input.field__input');
    this.success = this.querySelector('.newsletter-form__message--success');
    this.error = this.querySelector('.newsletter-form__message--error');

    if (this.form && this.input) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.form.addEventListener('submit', this.onSubmit.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();

    this.options = {
      method: 'POST',
      headers: { accept: 'application/json', 'content-type': 'application/json' },
      body: JSON.stringify({ email: this.input.value, list_id: this.listId })
    };

    fetch(`https://custom-checkouts.co.uk/firelabel/firelabel-klaviyo.php`, this.options)
      .then(response => response.json())
      .then(response => this.onSuccess(response))
      .catch(err => this.onError(err));
  }

  onSuccess(response) {
    if (response.status == 'success') {
      if (this.success && this.error) {
        this.success.classList.remove('hide');
        this.error.classList.add('hide');
      }

      this.input.setAttribute('aria-describedby', 'ContactFooter-success');

      this.input.removeAttribute('autofocus');
      this.input.removeAttribute('aria-invalid');
      this.input.removeAttribute('aria-describedby');
    }

    if (response.errors) {
      for (const error of response.errors) {
        this.onError(error.detail);
      }
    }
  }

  onError(err) {
    if (this.error && this.success) {
      this.error.classList.remove('hide');
      this.success.classList.add('hide');
    }

    this.input.setAttribute('autofocus', null);
    this.input.setAttribute('aria-invalid', true);
    this.input.setAttribute('aria-describedby', 'ContactFooter-error');

    this.input.removeAttribute('aria-describedby');

    console.error(err);
  }
}

customElements.define('klaviyo-form', KlaviyoForm);

class BulkOrderButton extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.isOpen = false;

    if (this.button) {
      this.button.addEventListener('click', e => {
        this.isOpen = !this.isOpen;

        let productInfoContainers = document.querySelectorAll('.product__info-container');

        if (productInfoContainers) {
          for (const productInfoContainer of productInfoContainers) {  
            productInfoContainer.classList.toggle('bulk-order', this.isOpen);
          }
        }
      });
    }
  }
}

customElements.define('bulk-order-button', BulkOrderButton);

class BackInStockForm extends HTMLElement {
  constructor() {
    super();

    let form = this.querySelector("form");

    // If there's no form, wrap contents in a new one
    if (!form) {
      form = document.createElement("form");
      form.append(...this.childNodes); // More efficient than a while loop
      this.appendChild(form);
    }

    this.form = form;

    this.form.addEventListener("submit", (e) => {
      e.preventDefault();

      const formData = new FormData(this.form),
        email = formData.get("contact[email]"),
        variantId = formData.get("variant_id");

      fetch("https://custom-checkouts.co.uk/firelabel/firelabel-back-in-stock.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
        },
        body: new URLSearchParams({
          email: email,
          variant: variantId
        }),
      })
      .then(resp => resp.json())
      .then(resp => {
        this.form.classList.toggle("success", resp.success);
        this.form.classList.toggle("error", !resp.success);
      });
    });
  }
}

customElements.define("back-in-stock-form", BackInStockForm);

class BackInStockAsyncCard extends HTMLElement {
  constructor() {
    super();
    this.loaded = false;
  }

  connectedCallback() {
    // const drawer = this.closest('drawer-component');
    // if (!drawer) return;
    // const trigger = document.getElementById(drawer.dataset.triggerId);
    // if (trigger) {
    //   trigger.addEventListener('click', () => this.load());
    // }

    this.load();
  }

  load() {
    if (this.loaded) return;
    this.loaded = true;
    const productUrl = this.dataset.productUrl;
    const variantId = this.dataset.variantId;
    if (!productUrl || !variantId) return;
    fetch(`${productUrl}?view=back-in-stock-card&variant=${variantId}`)
      .then((r) => r.text())
      .then((html) => {
        this.innerHTML = html;
      });
  }
}

customElements.define('back-in-stock-async-card', BackInStockAsyncCard);


function initSizeGuideTrigger() {
  let sizeGuideSummarys = document.querySelectorAll('.summary-pdp-size-guide');
  let sizeGuideTarget = document.getElementById('SizeGuideTrigger');

  if (sizeGuideSummarys.length > 0 && sizeGuideTarget) {
    sizeGuideTarget.addEventListener('click', (event) => {
      event.preventDefault();
      
      // Click each summary
      for (const sizeGuideSummary of sizeGuideSummarys) {
        if (!sizeGuideSummary.parentElement.open) {
          sizeGuideSummary.click();
        }
        setTimeout(function() {
          sizeGuideSummary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        },100);
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  initSizeGuideTrigger();

  let summarys = document.querySelectorAll('.summary-pdp-delivery-returns');
  let target = document.querySelector('a[href="#TriggerDeliveryAccordion"]');

  if (summarys.length > 0 && target) {
    target.addEventListener('click', (event) => {
      event.preventDefault();
      
      // Click each summary
      for (const summary of summarys) {
        summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (!summary.parentElement.open) {
          summary.click();
        }
      }
    });
  }
});

// Adds 'checked' class to parent label of checkbox when toggled
function updateCheckboxLabelClass(input) {
  var label = input.closest('label') || document.querySelector('label[for="' + input.id + '"]');
  if (label) {
    label.classList.toggle('checked', input.checked);
  }
}

function bindCheckboxLabelEvents() {
  document.querySelectorAll('input[type="checkbox"]').forEach(function(input) {
    updateCheckboxLabelClass(input);
  
    input.addEventListener('change', event => {
      updateCheckboxLabelClass(event.target);
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  bindCheckboxLabelEvents();
});

class ExpandableContent extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('[data-expand]');
    this.buttonReadMore = this.querySelector('[data-read-more]');
    this.buttonReadLess = this.querySelector('[data-read-less]');
    this.content = this.querySelector('.rte');
    this.inline = this.classList.contains('expandable-content--inline');
    this.isExpanded = false;

    if (this.button) {
      this.button.addEventListener('click', e => {
        this.isExpanded = !this.isExpanded;

        this.classList.toggle('expanded', this.isExpanded);

        if (!this.isExpanded) this.checkOverflow();
      });
    }
  }

  connectedCallback() {
    if (!this.button || !this.content) return;

    const check = () => this.checkOverflow();

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(check);
    } else {
      requestAnimationFrame(check);
    }
  }

  checkOverflow() {
    const isOverflowing = this.inline
      ? this.content.scrollWidth > this.content.clientWidth + 1
      : this.content.scrollHeight > this.content.clientHeight + 1;
    this.button.classList.toggle('hide', !isOverflowing);
  }
}

customElements.define('expandable-content', ExpandableContent);

class ExpandableContentInline extends HTMLElement {
  constructor() {
    super();

    this.expandButton = this.querySelector('[data-expand]');
    this.collapseButton = this.querySelector('[data-collapse]');
    this.isExpanded = false;

    if (this.expandButton) {
      this.expandButton.addEventListener('click', e => {
        this.isExpanded = true;
        this.classList.toggle('expanded', this.isExpanded);
      });
    }

    if (this.collapseButton) {
      this.collapseButton.addEventListener('click', e => {
        this.isExpanded = false;
        this.classList.toggle('expanded', this.isExpanded);
      });
    }
  }
}

customElements.define('expandable-content-inline', ExpandableContentInline);

async function refreshCartDrawer() {
  const drawer = document.querySelector('cart-drawer');
  if (!drawer) return;

  const shouldRemainOpen = drawer.classList.contains('active');

  const sectionIds = drawer.getSectionsToRender().map(s => s.id).join(',');
  const sectionHtml = await fetch(
    `/cart?sections=${sectionIds}&sections_url=${encodeURIComponent(window.location.pathname)}`,
    { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
  ).then(r => r.json());

  const cartJson = await fetch('/cart.js').then(r => r.json());

  drawer.renderContents(
    {
      id: 'refresh',
      sections: sectionHtml
    },
    { openDrawer: shouldRemainOpen }
  );

  updateSavingsBars(cartJson.original_total_price);
}

// Fires when going back in the browser to a cached page state
window.addEventListener('pageshow', (e) => {
  // Refresh the entire cart drawer
  if (e.persisted) refreshCartDrawer();
});
